export const GLOBAL_STATUS = {
  SUCCESS: 200,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  FORBIDDEN: 403,
};

export const USER_ROLE = {
  SUPER_ADMIN: 1,
  ADMIN: 2,
  AGENT: 3,
  USER: 4,
};

// Define the age range mapping
const AGE_RANGE = {
  1: "20-30",
  2: "30-40",
  3: "40-50",
  4: "50-60",
  5: "60+"
};

// Define the health priority mapping
const HEALTH_PRIORITY = {
  1: "Not Important",
  2: "Biggest Priority",
  3: "Moderately Important"
};

// Define the family mapping
const FAMILY = {
  1: "Partner",
  2: "Children",
  3: "Parents",
  4: "Grandparents",
  5: "Animals",
  6: "Single",
};

// Define to travel distance mapping
const TRAVEL_DISTANCE = {
  1: "2-4 Hours Flight",
  2: "4-8 Hours Flight",
  3: "8-16 Hours Flight",
  4: "Same Country",
};

// Define to travel distance mapping
const TRAVEL_DISTANCE_HOLIDAY = {
  1: "2-4 Hours Flight",
  2: "4-8 Hours Flight",
  3: "8-16 Hours Flight",
  4: "16-24 Hours+ Flight",
};

// Define to property owns mapping
const PROPERTIES_OWNS = {
  1: "0-1",
  2: "1-2",
  3: "2-3",
  4: "3-4",
};

// define to decision choices mapping
const DECISION_CHOICES = {
  1: "Yes",
  2: "No",
  3: "Doesn't Matter",
};
const DECISION_CHOICES_BOOLEAN = {
  1: "Yes",
  0: "No",
};

export const preferenceEnums = {
  AGE_RANGE,
  HEALTH_PRIORITY,
  FAMILY,
  TRAVEL_DISTANCE,
  PROPERTIES_OWNS,
  DECISION_CHOICES,
  DECISION_CHOICES_BOOLEAN,
  TRAVEL_DISTANCE_HOLIDAY,
};

//Enums for screen id
export const SCREENS_IDS = {};

export const IMAGE_TYPES = {
  TYPE_PHOTO_ID: 1,
  TYPE_HEADSHOT: 2,
  TYPE_DOCUMENT: 3,
};

export const PROPERTY_IMAGE_TYPES = {
  COVER_IMAGE: 1,
};

export const APPROVAL_STATUS = {
  PENDING: 1,
  REJECTED: 2,
  APPROVED: 3,
};

export const AREA_MEASURMENTS = {
  METER: 1,
  FEET: 2,
};

export const SUBSCRIPTION_PLAN_TYPE = {
  MONTHLY: 1,
  SEASONAL: 2,
  ANNUAL: 3,
};

export const SUBSCRIPTION_PLAN = {
  STANDARD: 1,
  BEGINNER: 2,
  PROFESSIONAL: 3,
  PREMIUM: 4,
};

export const SUBSCRIPTION_PLAN_DURATION = {
  [SUBSCRIPTION_PLAN_TYPE.MONTHLY]: 1,
  [SUBSCRIPTION_PLAN_TYPE.SEASONAL]: 6,
  [SUBSCRIPTION_PLAN_TYPE.ANNUAL]: 12,
};

export const SUBSCRIPTION_STATUS = {
  NOT_SUBSCRIBED: 1,
  PENDING: 2,
  INACTIVE: 3,
  ACTIVE: 4,
  EXPIRED: 5,
  CANCELLED: 6,
  ONCANCELLED: 10,
};

export const SUBSCRIPTION_PLATFORM = {
  NONE: 0,
  WEB: 1,
  ANDROID: 2,
  IOS: 3,
};

export const EXPORT_TYPE = {
  ALL: 1,
  GRID: 2,
};

export const STATUS_LABEL = {
  INACTIVE: "Inactive",
  ACTIVE: "Active",
  INVITE_SENT: "Invite Sent",
};

export const BUDGET_RANGE = {
  MIN: 0,
  MAX: 1000000,
};